import { render, staticRenderFns } from "./AccountingConnections.vue?vue&type=template&id=65a9103c&"
import script from "./AccountingConnections.vue?vue&type=script&lang=ts&"
export * from "./AccountingConnections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports